import { io, Socket } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_API_URL?.replace('/api', '') ||
  (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:3001');

class SocketService {
  private socket: Socket | null = null;
  private listeners: Map<string, Set<Function>> = new Map();
  private joinedMachineIds: Set<string> = new Set();

  connect(token?: string) {
    if (this.socket) {
      if (!this.socket.connected) {
        this.socket.connect();
      }
      return;
    }

    this.socket = io(SOCKET_URL, {
      path: '/socket.io',
      auth: token ? { token } : undefined,
      transports: ['websocket', 'polling'],
    });

    this.socket.on('connect', () => {
      console.log('[Socket] Connected');
      this.joinedMachineIds.forEach((machineId) => {
        this.socket?.emit('join_machine', machineId);
      });
    });

    this.socket.on('production_update', (data: any) => {
      this.emit('production_update', data);
    });

    this.socket.on('telemetry_update', (data: any) => {
      this.emit('telemetry_update', data);
    });
  }

  disconnect() {
    this.socket?.disconnect();
    this.socket = null;
  }

  joinMachine(machineId: string) {
    if (!machineId) return;
    this.joinedMachineIds.add(machineId);
    if (this.socket?.connected) {
      this.socket.emit('join_machine', machineId);
    }
  }

  joinMachines(machineIds: string[]) {
    machineIds.forEach((id) => this.joinMachine(id));
  }

  on(event: string, callback: Function) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set());
    }
    this.listeners.get(event)!.add(callback);
  }

  off(event: string, callback: Function) {
    this.listeners.get(event)?.delete(callback);
  }

  private emit(event: string, data: any) {
    this.listeners.get(event)?.forEach(cb => cb(data));
  }
}

const socketService = new SocketService();
export default socketService;
